<span>{{ label() || ('shared.table-view-link.view' | translate) }}</span>
<svg-icon key="chevron-right-16" size="16"></svg-icon>
